import { Alert } from "@vinomofo/components";

interface ToastProps {
  label?: string;
  message?: string;
}

export const InfoToast = ({
  label = "Hey Mofo!",
  message = "",
}: ToastProps): JSX.Element => {
  return (
    <Alert
      padding={1}
      px={1}
      boxShadow="none"
      intent="info"
      label={label}
      message={message}
    />
  );
};
